import { Checkbox, Flex, Text } from '@byecode/ui'
import type { ApplicationSettingAuthentication } from '@lighthouse/core'
import React from 'react'
import styled from 'styled-components'

import { getHttpUrl } from '../../../utils'

const SCxAgreementText = styled(Text)`
    font-size: 12px;
    color: var(--color-gray-600);

    a {
        color: var(--color-app-main);
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
`

interface AgreementCheckboxProps {
    disableMargin?: boolean
    authentication: ApplicationSettingAuthentication
    checked: boolean
    onChange: (checked: boolean) => void
}

export const AgreementCheckbox: React.FunctionComponent<AgreementCheckboxProps> = ({
    disableMargin,
    authentication,
    checked,
    onChange
}) => {
    const { login } = authentication
    const { requireAgree } = login

    // 如果没有启用协议要求，不显示组件
    if (!requireAgree?.enable) {
        return null
    }

    const userProtocolName = requireAgree.userProtocol?.name || '《用户协议》'
    const privacyPolicyName = requireAgree.privacyPolicy?.name || '《隐私条款》'
    const userProtocolUrl = requireAgree.userProtocol?.url || ''
    const privacyPolicyUrl = requireAgree.privacyPolicy?.url || ''

    return (
        <Flex alignItems="center" justifyContent="center" gap={8} mt={disableMargin ? undefined : 16}>
            <Checkbox size="sm" color="var(--color-app-main)" checked={checked} onChange={e => onChange(e.target.checked)} />
            <SCxAgreementText>
                同意
                <a href={getHttpUrl(userProtocolUrl)} target="_blank" rel="noreferrer">
                    {userProtocolName}
                </a>
                和
                <a href={getHttpUrl(privacyPolicyUrl)} target="_blank" rel="noreferrer">
                    {privacyPolicyName}
                </a>
            </SCxAgreementText>
        </Flex>
    )
}

export const ConfirmContent = ({ authentication }: { authentication: ApplicationSettingAuthentication }) => {
    const { login } = authentication
    const { requireAgree } = login

    // 如果没有启用协议要求，不显示组件
    if (!requireAgree?.enable) {
        return null
    }

    const userProtocolName = requireAgree.userProtocol?.name || '《用户协议》'
    const privacyPolicyName = requireAgree.privacyPolicy?.name || '《隐私条款》'
    const userProtocolUrl = requireAgree.userProtocol?.url || ''
    const privacyPolicyUrl = requireAgree.privacyPolicy?.url || ''

    return (
        <SCxAgreementText>
            请先阅读并同意
            <a href={getHttpUrl(userProtocolUrl)} target="_blank" rel="noreferrer">
                {userProtocolName}
            </a>
            和
            <a href={getHttpUrl(privacyPolicyUrl)} target="_blank" rel="noreferrer">
                {privacyPolicyName}
            </a>
        </SCxAgreementText>
    )
}
